import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import { format, isMatch, parse, subDays } from 'date-fns';
import useSearchHooks from '../../../store/hotel/search-hooks';

export default function DateRangeSelection() {
  const [checkIn, setCheckIn] = useState(null);
  const [checkOut, setCheckOut] = useState(null);
  const { setSearchParameters, search } = useSearchHooks();
  const { checkIn: filterCheckIn, checkOut: filterCheckOut } = search;
  useEffect(() => {
    if (isMatch(filterCheckIn, 'MM/dd/yyyy')) {
      setCheckIn(() => parse(filterCheckIn, 'MM/dd/yyyy', new Date()));
    } else {
      setCheckIn(null);
    }
    if (isMatch(filterCheckOut, 'MM/dd/yyyy')) {
      setCheckOut(() => parse(filterCheckOut, 'MM/dd/yyyy', new Date()));
    } else {
      setCheckOut(null);
    }
  }, [filterCheckIn, filterCheckOut]);
  return (
    <>
      <div className="rs_form_row rs_date rs_chk_in_row rs_initial_hide rs_1365_33">
        <div className="pointer rs_date_input_container">
          <FontAwesomeIcon icon={faCalendar} className="fa-location-icon" />
          <p className={checkIn ? 'hide-placeholder d-block' : 'hide-placeholder '}>Check in</p>
          <DatePicker
            minDate={new Date()}
            className={checkIn ? 'rs_chk_in rs_autosuggest_act rs_autosuggest' : 'rs_chk_in rs_autosuggest'}
            selected={checkIn}
            onChange={(date) => {
              setSearchParameters({ checkIn: format(date, 'MM/dd/yyyy') });
            }}
            selectsStart
            startDate={checkIn}
            endDate={checkOut}
            placeholderText="Check in"
            dateFormat="MM/dd/yyyy"
          />
        </div>
      </div>
      <div className="rs_form_row rs_date rs_chk_out_row rs_initial_hide rs_1365_33">
        <div className="pointer rs_date_input_container">
          <FontAwesomeIcon icon={faCalendar} className="fa-location-icon" />
          <p className={checkOut ? 'hide-placeholder d-block' : 'hide-placeholder '}>Check out</p>
          <DatePicker
            className={checkOut ? 'rs_chk_out rs_autosuggest_act rs_autosuggest' : 'rs_chk_out rs_autosuggest'}
            selected={checkOut}
            onChange={(date) => {
              setSearchParameters({ checkOut: format(date, 'MM/dd/yyyy') });
            }}
            selectsEnd
            startDate={checkIn}
            endDate={checkOut}
            minDate={checkIn || subDays(checkIn, -1)}
            placeholderText="Check out"
            dateFormat="MM/dd/yyyy"
          />
        </div>
      </div>
    </>
  );
}
